/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 * Product Card Tariff new design component
 *
 * @author Evgeniy Naumov
 * @version 1.23.2
 * @since 1.23.0
 */

import { FC, useCallback } from 'react';

import { RatePlanCard } from '@nexign/scc-ui-kit';
import { IRatePlanParams } from '@nexign/scc-ui-kit/lib/components/RatePlanCard/types';

import { TProductCardTariffNewProps } from '../ProductCardTariff';

const TariffCardNew: FC<TProductCardTariffNewProps> = (props) => {
    const { pageProductTranslation, setRange, ...newCardTariffParams } = props;

    const handleSetRatePlansParams = useCallback(
        (params: IRatePlanParams) => {
            if (!params.packId) return;
            setRange({
                id: params.ratePlanId,
                rangeId: params.packId,
            });
        },
        [setRange],
    );

    return (
        <RatePlanCard
            detailsTitle={pageProductTranslation.cards.moreInfoLabel}
            key={props.id}
            ratePlan={newCardTariffParams}
            rowParams={props.rowParams || {}}
            setRatePlansParams={handleSetRatePlansParams}
        />
    );
};

export default TariffCardNew;
